import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: fit-content;
`;

export const OptionsPopup = styled.div`
  position: absolute;
  top: 35px;
  /* background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), #f2f2f2), linear-gradient(#ffffff, #ffffff); */
  background: #fff;
  box-shadow: 0 -1px 10px 0 rgba(0, 0, 0, 0.5);
  z-index: 999;
  border-radius: 5px;
  left: ${(props) => (props.left ? props.left + '%' : '50%')};
  transform: translate(-50%);
  &:before {
    content: '';
    ${(props) =>
      props.$arrowRight !== undefined
        ? css`
            right: ${props.$arrowRight}px;
            transform: rotate(45deg);
          `
        : css`
            left: ${props.left ? 50 + (Math.abs(props.left) - 50) * 2 + '%' : '50%'};
            transform: translate(-50%, 0) rotate(45deg);
          `}
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: #fff;
    ${(props) =>
      props.$flip
        ? css`
            bottom: -10px;
            border-right: solid 2px #a0a0a073;
            border-bottom: solid 2px #a0a0a073;
            border-top-left-radius: 100%;
          `
        : css`
            top: -10px;
            border-left: solid 2px #a0a0a073;
            border-top: solid 2px #a0a0a073;
            border-bottom-right-radius: 100%;
          `}
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      color: #fff;
      background: #464b51;
      &:before {
        background-color: #464b51;
        border-color: #a0a0a033;
      }
    `}

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      color: var(--cp-text);
      background: var(--cp-surface);
      &:before {
        background-color: var(--cp-surface);
        border-color: var(--cp-border);
      }
    `}
  ${(props) =>
    props.$arrowRight !== undefined &&
    css`
      left: auto;
      transform: none;
    `}
`;

export const PopupContainer = styled.div`
  position: fixed;
  z-index: 999;
  background-color: ${(props) => (props.theme.theme === 'dark' ? '#393e44' : '#fff')};
  border-radius: 4px;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.5);
  &:before {
    content: '';
    right: ${(props) => props.$arrowOffset ?? 20}px;
    transform: rotate(45deg);
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: ${(props) => (props.theme.theme === 'dark' ? '#393e44' : '#fff')};
    ${(props) =>
      props.$flip
        ? css`
            bottom: -10px;
            border-right: solid 2px #a0a0a073;
            border-bottom: solid 2px #a0a0a073;
            border-top-left-radius: 100%;
          `
        : css`
            top: -10px;
            border-left: solid 2px #a0a0a073;
            border-top: solid 2px #a0a0a073;
            border-bottom-right-radius: 100%;
          `}
  }
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      color: var(--cp-text);
      background-color: var(--cp-surface);
      border: 1px solid var(--cp-border);
      border-radius: 12px;
      box-shadow: 0 12px 32px rgba(16, 24, 32, 0.28);
      &:before {
        background-color: var(--cp-surface);
        border-color: var(--cp-border);
      }
    `}
`;

export const Option = styled.div`
  white-space: pre;
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  display: flex;
  align-items: center;
  color: #000;
  height: 45px;
  font-size: 13px;
  padding: 0 15px;
  min-width: 150px;
  i {
    margin-right: 10px;
    font-size: 15px;
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      color: #ccc;
    `}

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      color: var(--cp-text);
    `}
`;

export const OptionsSeparator = styled.div`
  height: 1px;
  opacity: 0.6;
  background-color: ${(props) => (props.theme.theme === 'dark' ? '#555' : 'rgba(85, 85, 85, 0.2)')};
`;
